import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import format from './i18n-format';
import { map as _map, isEmpty as _isEmpty } from 'lodash-es';
import Cookies from 'js-cookie';

const supported = JSON.parse(localStorage.getItem('supportedLocales'));
const getDefault = Cookies.get('locale');
const externalSupportedLanguages = ['th_TH', 'en_US', 'in_ID'];

// Function to convert Unicode escape sequences to actual text
function convertUnicodeToActualText(unicodeString) {
  return unicodeString.replace(/\\u[\dA-F]{4}/gi, function (match) {
    return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16));
  });
}

i18next
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // lng: 'en', // Enable this if we are not detecting user language

    // All supported languages
    supportedLngs: !_isEmpty(getDefault) && [
      getDefault,
      ..._map(supported, language => language?.key),
      ...externalSupportedLanguages
    ],

    // Allows "en-US" and "en-UK" to be implicitly supported when "en"
    // Please refer below URL to know more about below config settings
    // https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    nonExplicitSupportedLngs: true,

    // Fallback language
    // fallbackLng: getDefault || _find(supported, language => language?.default)?.key || 'en_US',
    fallbackLng: 'en_US',
    interpolation: {
      escapeValue: false,
      format
    },
    react: {
      useSuspense: true,
      bindI18n: 'languageChanged'
    },
    backend: {
      loadPath: `${process.env.REACT_APP_LOCALIZATION_SERVER_URL}/locales/resources/default/Turbocharger_{{lng}}.json?`,
      parse: data => {
        const jsonData = JSON.parse(data);
        // Convert Unicode escape sequences to actual text for each key in the JSON
        for (const key in jsonData) {
          if (jsonData.hasOwnProperty(key)) {
            jsonData[key] = convertUnicodeToActualText(jsonData[key]);
          }
        }
        return jsonData;
      },
      allowMultiLoading: false
    },
    // Detect users selected language
    // https://github.com/i18next/i18next-browser-languageDetector#introduction
    detection: {
      // order and from where user language should be detected
      order: ['cookie'],

      // keys or params to lookup language from
      lookupCookie: 'locale',
      lookupFromPathIndex: 0,
      lookupFromSubdomainIndex: 0,

      // cache user language on
      caches: ['cookie'],
      // excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)

      // optional expire and domain for set cookie
      cookieMinutes: 1440,
      cookieDomain: process.env.REACT_APP_COOKIE_PATH,
      cookieOptions: { path: '/', cookieDomain: process.env.REACT_APP_COOKIE_PATH }
    }

    // debug: process.env.NODE_ENV === 'development'
  });

export default i18next;
